import React, { useState, useEffect } from 'react'
import './policy.css'
import {
  acceptTOS,
  checkIfPoliciesAccepted,
  fetchEULAandPrivacyPolicy,
} from '../utils/apis/api'

const PolicyDialog = () => {
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState('privacy')

  const fetchPolicies = async () => {
    try {
      setLoading(true)
      const data = await fetchEULAandPrivacyPolicy()
      setContent(data)
    } catch (err) {
      console.error(err)
      setContent({
        privacy_policy: '⚠️ Could not load Privacy Policy.',
        terms_of_use: '⚠️ Could not load Terms of Use.',
      })
    } finally {
      setLoading(false)
    }
  }

  // On mount: auto-check if the user needs to accept a new TOS version
  useEffect(() => {
    const checkTOSAcceptance = async () => {
      const userId = sessionStorage.getItem('user_id')
      if (!userId) return

      try {
        const latestDoc = await fetchEULAandPrivacyPolicy()
        const userAcceptance = await checkIfPoliciesAccepted(userId)

        // userAcceptance.latest_version = current latest version in the DB
        // userAcceptance.legal_document.version_number = version the user last accepted
        if (
          !userAcceptance ||
          userAcceptance.latest_version !==
            userAcceptance.legal_document.version_number
        ) {
          // No prior acceptance (404) or version mismatch → show modal
          setContent(latestDoc)
          setOpen(true)
        }
      } catch (err) {
        console.error('Error checking TOS acceptance on mount:', err)
      }
    }

    checkTOSAcceptance()
  }, [])

  // When the modal is opened via the trigger link, fetch policies if not already loaded
  useEffect(() => {
    if (open && !content) {
      fetchPolicies()
    }
  }, [open])

  const handleAccept = async () => {
    console.log(sessionStorage.getItem('user_id'))
    console.log(content.id)

    const payload = {
      user_id: sessionStorage.getItem('user_id'),
      TOS_version_id: content.id,
    }

    try {
      const res = await acceptTOS(payload)

      if (!res.ok) {
        throw new Error(`Failed to accept TOS: ${res.status}`)
      }

      console.log('TOS accepted successfully')
      localStorage.setItem('policiesAccepted', 'true')
      setOpen(false)
    } catch (err) {
      console.error('Error accepting TOS:', err)
      alert('⚠️ Failed to accept Terms of Service. Please try again.')
    }
  }

  return (
    <>
      {/* Trigger Link */}
      <span className="policy-link" onClick={() => setOpen(true)}>
        Privacy Policy & Terms of Service
      </span>

      {/* Dialog */}
      {open && (
        <div className="dialog-overlay">
          <div className="dialog-container">
            {/* Header with Tabs */}
            <div className="dialog-tabs">
              <button
                onClick={() => setActiveTab('privacy')}
                className={`tab-btn ${activeTab === 'privacy' ? 'active' : ''}`}
              >
                Privacy Policy
              </button>
              <button
                onClick={() => setActiveTab('terms')}
                className={`tab-btn ${activeTab === 'terms' ? 'active' : ''}`}
              >
                Terms of Service
              </button>
            </div>

            {/* Content */}
            <div className="dialog-content">
              {loading ? (
                <p>Loading...</p>
              ) : content ? (
                <>
                  {activeTab === 'privacy' && (
                    <div>
                      <h3>Privacy Policy</h3>
                      <p className="text-block">{content.privacy_policy}</p>
                    </div>
                  )}
                  {activeTab === 'terms' && (
                    <div>
                      <h3>Terms of Service</h3>
                      <p className="text-block">{content.terms_of_service}</p>
                    </div>
                  )}
                </>
              ) : (
                <p>No content available.</p>
              )}
            </div>

            {/* Footer */}
            <div className="dialog-footer">
              <button className="btn-success" onClick={handleAccept}>
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PolicyDialog
